import projdata from "../proj-data";
import ToggleProjectView from "./ToggleProjectView";

export default function Projects() {
	return (
		<section id="projects">
			<h1 className="my-work-title">My work</h1>
			<div id="proj-container">
				<ToggleProjectView projects={projdata} />
			</div>
		</section>
	);
}
